import {
  Box,
  Stack,
  MenuItem,
  Button,
  Typography,
  TextField,
} from "@mui/material";
import { useState, useEffect } from "react";
import React from "react";
import { InfoApi } from "../../api/InfoApi";
import { useTranslation } from "react-i18next";
import { getLang } from "../../helper/LangHelper";
import AdminLeaderboardCard from "../../components/app/AdminLeaderboardCard";
import EventStatisticQueryForm from "../../components/adminStatistic/EventStatisticQueryForm";
import { StatApi } from "../../api/StatApi";
import EventStatCard from "../../components/adminStatistic/EventStatCard";
import SkillStatCard from "../../components/adminStatistic/SkillStatCard";
import { dateValueToYYYYMMDD } from "../../helper/TimeHelper";
import { cs } from "date-fns/locale";

function downloadCsvData(csvData, filename) {
  console.debug("downloadCsvData: ", csvData, filename);
  // Convert csvData to CSV string
  let csvContent = "";

  for (let row of csvData) {
    // console.debug("row: ", row);
    // Convert each row to a comma-separated string
    const rowString = row.map(item => {
      // Escape double quotes by replacing them with two double quotes
      const escapedItem = item.toString().replace(/"/g, '""');
      // Wrap the item in double quotes
      return `"${escapedItem}"`;
    }).join(",");
    // Append the row string to the CSV content
    csvContent += rowString + "\n";
  }

  console.debug("csvContent: ", csvContent);
  // Create a Blob from the CSV string
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  // Create a link element
  const link = document.createElement("a");
  // Create a URL for the Blob    
  const url = URL.createObjectURL(blob);
  // Set the link's href to the Blob URL
  link.setAttribute("href", url);
  // Set the download attribute with the filename
  link.setAttribute("download", filename);
  // Append the link to the body
  document.body.appendChild(link);
  // Programmatically click the link to trigger the download
  link.click();
  // Clean up by removing the link and revoking the Blob URL

  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  console.debug("CSV file downloaded: ", filename);
}

function generateCsvData(eventStat, skillStatList) {
  console.debug("generateCsvData: ", eventStat, skillStatList);
  // Generate CSV data from eventStat and skillStatList
  const headerColumns = [
    "Skill Name",
    "Rank",
    "Display Name",
    "Score",
    "Group",
    "Group Number",
  ];

  let csvData = [];

  // Add header row
  csvData.push(headerColumns);

  // loop through skillStatList
  for (let skillStat of skillStatList) {
    console.debug("skillStat: ", skillStat);
    // headerColumns.push(skillStat.skill_name);
    let skillName = skillStat.info.name;

    let rank = 1;
    for (let data of skillStat.top_records) {
      let displayName = data.display_name || "";
      let score = data.skill_score || 0;
      let group = data.group || "";
      let groupNum = data.group_num || "";


      csvData.push([
        skillName,
        rank,
        displayName,
        score,
        group,
        groupNum,
      ])
      rank++;
    }

    // console.debug("csvData: ", csvData);


  }

  return csvData;

}


export default function AdminEventStatSection({ mode = "admin", userID }) {
  const [eventList, setEventList] = useState([]);
  const [event, setEvent] = useState(null);
  const [eventStat, setEventStat] = useState(null);
  const [skillStatList, setSkillStatList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const isAdminUser = mode === "admin";
  userID = userID || 0;

  const { t } = useTranslation();

  let lang = getLang();

  useEffect(() => {
    if (isAdminUser) {
      loadAllEventList();
    } else {
      loadUserEventList();
    }
  }, []);


  const updateEventList = (newEventList) => {
    setEventList(newEventList);
    if (newEventList.length === 0) {
      setEvent(null);
    } else {
      setEvent(newEventList[0]);
    }
  }

  const loadUserEventList = async () => {
    // console.debug("currentMemberID: ", currentMemberID);
    setIsLoading(true);

    const result = await InfoApi.getUserEventList(userID);
    setIsLoading(false);
    setIsLoaded(true);
    
    console.debug("result: ", result);
    updateEventList(result);

  };

  const loadAllEventList = async () => {
    setIsLoading(true);

    // console.debug("currentMemberID: ", currentMemberID);
    const result = await InfoApi.getEventList();
    setIsLoading(false);
    setIsLoaded(true);

    console.debug("result: ", result);
    updateEventList(result);
    // setEventList(result);
  };

  const onQuery = async (inputData) => {
    console.debug("onQuery: ", inputData);
    const eventID = inputData.eventID || 0;
    // const timeslotID = inputData.timeslotID || 0;
    // const skillID = inputData.skillID || 0;
    const selectedDate = inputData.selectedDate || null;
    const selectedDateStr = selectedDate ? dateValueToYYYYMMDD(selectedDate) : "";

    console.debug("selectedDate: ", selectedDate);

    // InfoApi.getp
    const result = await StatApi.getEventStat(eventID, selectedDateStr);
    console.debug("result: ", result);
    if (!result) {
      alert("Failed to load statistics");
      return;
    }
    setEventStat(result.event_stat);
    setSkillStatList(result.skill_stat_list);
  }

  const onExportCSV = async () => {
    console.debug("exportCSV: ", event);
    if (!event) {
      alert("Please select an event first");
      return;
    }

    const csvData = generateCsvData(eventStat, skillStatList);
    const eventName = event.name_en || "Event";
    const filename = `event_stat_${eventName}.csv`;
    console.debug("csvData: ", csvData);
    console.debug("filename: ", filename);
    downloadCsvData(csvData, filename);
  };

  const hasQuery = eventStat !== null && skillStatList.length > 0;


  // const loadEventList = async () => {
  //   // console.debug("currentMemberID: ", currentMemberID);
  //   const result = await InfoApi.getEventList();
  //   console.debug("result: ", result);
  //   setEventList(result);
  //   if (result.length === 0) {
  //     setEvent(null);
  //   } else {
  //     setEvent(result[0]);
  //   }
  //   // setEventList(result);
  // };

  // if (!event) {
  //   return <Box>Loading...</Box>;
  // }
  if (isLoading) {
    return <Box>Loading...</Box>;
  }

  if (isLoaded && eventList.length === 0) {
    return <Box>暫時沒有進行中的活動</Box>;
  }

  const eventStatCard = eventStat ? <EventStatCard stat={eventStat} /> : <></>;
  const skillStatCards = skillStatList.map((skillStat) => {
    return <SkillStatCard stat={skillStat} />;
  });




  return (
    <Stack direction="column" spacing={2}>
      <EventStatisticQueryForm eventList={eventList} onQuery={onQuery}>
      </EventStatisticQueryForm>

      {
        hasQuery &&
        <Button variant="contained" onClick={onExportCSV}>
          {t("button.export_csv")}
        </Button>

      }

      <Stack>
        {eventStatCard}
        {skillStatCards}
      </Stack>
      {/* {leaderboardTable} */}
      <Box>
        <pre>
          {/* {JSON.stringify(eventList, null, 2)} */}

          {/* {JSON.stringify(leaderboard, null, 2)} */}
          {/* {JSON.stringify(event, null, 2)} */}
        </pre>
      </Box>

    </Stack>
  );
}
